export const ONE_UPPERCASE = new RegExp(/(?=.*?[A-Z])/);
export const ONE_LOWERCASE = new RegExp(/(?=.*?[a-z])/);
export const ONE_DIGIT = new RegExp(/(?=.*?[0-9])/);
export const IS_VALID_CSV = new RegExp(/(.*,\s*.*)|(.*\n.*)/);
